import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `.customMultiselect {
	/* Header is a block-level flex row. Inside the \`max-content\` overlay its
	   width tracks its flex content, so with the search input removed (filter=false)
	   only the toggle-all checkbox is left and the header shrink-wraps to that
	   checkbox — a small box detached from the panel. Force it to span the panel
	   and keep its single child left-aligned so it reads as a normal first row.
	   With the filter present the input already fills the row, so full width and
	   flex-start are a no-op there. */
	& .p-multiselect-header {
		width: 100%;
		justify-content: flex-start;
		/* Match the option-row inset: list \`<ul>\` padding (0.25rem) + option
		   padding-inline (0.75rem) = 1rem, so the toggle-all checkbox lines up
		   with the per-option checkboxes below it. */
		padding-inline: 1rem;
	}

	& .p-multiselect-option-selected {
		background: transparent !important;
	}

	& .p-multiselect-option{
		color: ${dt('select.overlay.color')} !important;
		/* Keep each option on one line. With \`width: max-content\` on the overlay,
		   an unbreakable option lets the panel grow to the longest label so no
		   multi-word label takes a soft-wrap before using the panel's full width. */
		white-space: nowrap;
		overflow: visible;
		text-overflow: clip;
	}

	/* Let the flex label shrink so the selected value never slides under the
	   absolutely-positioned clear/dropdown icons. */
	& .p-multiselect-label-container {
		min-width: 0;
	}

	/* Selected-items container: chips must wrap onto new lines so a long selection
	   doesn't stretch the multiselect past the viewport. */
	& .p-multiselect-label {
		flex-wrap: wrap;
		gap: 0.25rem;
		align-items: center;
	}
}

p-multiselect.customMultiselect {
	/* The root is \`display: inline-flex\`, so without an explicit width it shrinks to
	   its content (placeholder + icon) and, in a flex filter row, leaves a gap to the
	   right of its label. Fill the host's allotted slot like the single-select does
	   (whose label uses \`width: 1%; flex: 1 1 auto\`). The overlay keeps its own
	   fit-to-content width via \`.p-multiselect-overlay.customMultiselect\` below. */
	width: 100%;
	max-width: 100%;
}

/* Body-appended overlay: at least the trigger width (set inline by the
   component as \`min-width\`), free to grow via \`max-content\` to fit the longest
   one-line option, capped at the viewport so it never overflows the screen.
   The cap is the viewport rather than a fixed rem so long labels (e.g.
   legislation / organization names) still show on a single line without
   clipping; \`max-content\` keeps short dropdowns tight regardless of the cap. */
.p-multiselect-overlay.customMultiselect {
	width: max-content;
	max-width: 90vw;
}

`;
